import { useState, useEffect } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import "./TestimonialSectionNew.css";

const testimonials = [
  {
    name: "Hariharan Balasubramanian",
    position: "Solution Architecture Senior Manager",
    track: "DFA 4.0",
    image: "images/Home/Testimonial/Hariharan-inactive.jpg",
    activeimg: "images/Home/Testimonial/Hariharan-new.png",
    description:
      "DFA 4.0 is a well-curated course that offers a strong overview of Accenture’s capabilities and ways of working.",
  },
  {
    name: "Priyanka Pareek",
    position: "Solution Architecture Manager",
    track: "DFA 4.0",
    image: "images/Home/Testimonial/Priyanka-inactive.png",
    activeimg: "images/Home/Testimonial/Priyanka.png",
    description:
      "The DFA training was comprehensive and engaging, helping me gain insights and improve my professional skills.",
  },
  {
    name: "Nitin Chaudari",
    position: "Business Architecture Manager",
    track: "DFA 4.0",
    image: "images/Home/Testimonial/Nitin-inactive.png",
    activeimg: "images/Home/Testimonial/Nitin.png",
    description:
      "I’m proud to have completed the DFA 4.0 program - a transformative experience that enhanced my professional growth.",
  },
  {
    name: "Ragamallika Gunduku",
    position: "App Automation Eng Manager",
    track: "DFA 4.0",
    image: "images/Home/Testimonial/Ragamallika-inactive.png",
    activeimg: "images/Home/Testimonial/Ragamallika.png",
    description:
      "DFA is an extremely useful training that boosts productivity with rich resources across various topics.",
  },
  {
    name: "Puneet Ahluwalia",
    position: "Managing Director, ATCI Cyber Strategy Lead",
    track: "Security Learning ",
    image: "images/Home/Testimonial/PuneetAhluwalia-inactive.png",
    activeimg: "images/Home/Testimonial/PuneetAhluwalia.png",
    description:
      "Security Learning team is a strategic engine fuelling innovation, inclusivity, and competitive advantage through focused cybersecurity learning initiatives by continuously shaping the workforce to meet today’s challenges and tomorrow’s opportunities — ensuring we remain future-ready to service our clients.",
  },
  {
    name: "Nilay Mehta",
    position: "Managing Director",
    track: "Tech Tales",
    image: "images/Home/Testimonial/NilayMehta-inactive.png",
    activeimg: "images/Home/Testimonial/NilayMehta.png",
    description:
      "Over the last few months, we’ve had a very interesting journey, progressing through multiple levels. It was truly engaging and impactful.I’d highly recommend it to anyone who can set aside time for it. I assure you; it’s well worth the investment. By the end of the course, you’ll be well-prepared to handle any kind of client interaction this year.",
  },

  {
    name: "Vasudev Puranik",
    position: "Managing Director",
    track: "Tech Tales",
    image: "images/Home/Testimonial/VasudevPuranik-inactive.png",
    activeimg: "images/Home/Testimonial/VasudevPuranik.png",
    description:
      "Insightful session by the respective trainers and the presentation with the jury helped those learnings to get applied alongside the contribution of the team members. Thanks to the Tech Tales Team for making it possible.",
  },
  {
    name: "Sarvendra Tyagi",
    position: "Data Eng, Mgmt and Governance Assoc Mgr",
    track: "Understanding Client Centricity (UCC)",
    image: "images/Home/Testimonial/avatar-men-inactive.png",
    activeimg: "images/Home/Testimonial/avatar-men.png",
    description:
      "UCC training has been a truly refreshing experience. The concept was entirely client-centric, explained in depth, listened to concerns, and tailored solutions to our project challenges. The scenario-based role plays helped us build skills that will make a big impact on future client opportunities.",
  },
  {
    name: "Hemanth Annappa",
    position: "Custom Software Engineering Manager",
    track: "Exe(c)lerate EMEA",
    image: "images/Home/Testimonial/avatar-men-inactive.png",
    activeimg: "images/Home/Testimonial/avatar-men.png",
    description:
      "I liked the insights on CCI, CQI, and opportunity stages. Key takeaways included security, timely risk callouts, building a rapport with the CFO, and understanding finance. Overall, it was a good blend of learnings that helped broaden our perspective as effective delivery leads.",
  },
  {
    name: "Shalabh Gautam",
    position: "Scrum Master Associate Manager",
    track: "Associate Manager Experience School (AMES)",
    image: "images/Home/Testimonial/avatar-men-inactive.png",
    activeimg: "images/Home/Testimonial/avatar-men.png",
    description:
      "Participating in the AMES program has been a transformative experience that has enhanced my leadership capabilities and strategic thinking. The case studies helped me gain a deeper understanding of team dynamics, decision-making under pressure, and effective communication strategies. I feel more confident leading cross-functional teams, managing stakeholder expectations, and driving results. I strongly recommend AMES to aspiring leaders. ",
  },
  {
    name: "Shaik Shoib Mohammed",
    position: "Infra Managed Service Sr Analyst",
    track: "Major Incident Management",
    image: "images/Home/Testimonial/avatar-men-inactive.png",
    activeimg: "images/Home/Testimonial/avatar-men.png",
    description:
      "The training was insightful, especially in understanding the structured approach to incident resolution and stakeholder communication during critical events. The hands-on scenarios were useful in preparing for real-world situations. I feel more confident in managing high-pressure incidents effectively, ensuring minimal disruption.",
  },
  {
    name: "Pranita M. Nagotkar",
    position: "Quality Engineering Manager",
    track: "Delivery Lead Essentials ",
    image: "images/Home/Testimonial/avatar-men-inactive.png",
    activeimg: "images/Home/Testimonial/avatar-men.png",
    description:
      "The program is an excellent initiative tailored to equip new Delivery Leads with the right knowledge, tools, and confidence to perform their roles effectively. The modules are well-curated, and the instructors demonstrated deep expertise. Their ability to connect real-world experience with theory enriched the experience. The enrichment sessions were impactful with practical learning. The program was highly engaging and serves as a strong foundation for anyone stepping into a Delivery Lead role.",
  },
];

const TestimonialSectionNew = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const testimonialsPerView = 3;
  const totalTestimonials = testimonials.length;
  const autoRotateInterval = 5000; // Rotate every 5 seconds

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % totalTestimonials);
  };

  const goToPrev = () => {
    setCurrentIndex(
      (prev) => (prev - 1 + totalTestimonials) % totalTestimonials
    );
  };

  const goToIndex = (index) => {
    setCurrentIndex(index);
  };

  const getVisibleTestimonials = () => {
    const visible = [];
    for (let i = 0; i < testimonialsPerView; i++) {
      visible.push(testimonials[(currentIndex + i) % totalTestimonials]);
    }
    return visible;
  };

  const visibleTestimonials = getVisibleTestimonials();

  useEffect(() => {
    if (isPaused) return; // Skip if paused

    const interval = setInterval(() => {
      goToNext();
    }, autoRotateInterval);

    return () => clearInterval(interval);
  }, [currentIndex, isPaused]);

  return (
    <div
      className="testimonial-carousel"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <button
        className="testi-nav-arrow left"
        onClick={goToPrev}
        aria-label="Previous testimonial"
      >
        <FaArrowLeft />
      </button>

      <div className="testimonial-wrapper">
        {visibleTestimonials.map((item, index) => (
          <div
            className={`testimonial-card ${
              index === 0 ? "active" : "inactive"
            }`}
            key={index}
          >
            <div className="testimonial-img-box">
              <img
                src={index === 0 ? item.activeimg : item.image}
                alt={item.name}
                className="testimonial-image"
              />
            </div>
            <div className="testimonial-content">
              <h3 className="testimonial-name">{item.name}</h3>
              <p className="testimonial-position">
                {item.position} <span>{item.track}</span>
              </p>
              {index === 0 && (
                <p className="testimonial-description">{item.description}</p>
              )}
            </div>
          </div>
        ))}
      </div>

      <button
        className="testi-nav-arrow right"
        onClick={goToNext}
        aria-label="Next testimonial"
      >
        <FaArrowRight />
      </button>

      <div className="testi-pagination-dots">
        {testimonials.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === currentIndex ? "active" : ""}`}
            onClick={() => goToIndex(index)}
            style={{ cursor: "pointer" }}
            aria-label={`Go to testimonial ${index + 1}`}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default TestimonialSectionNew;
